"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.replace");
var _jobLog = require("@/api/job/jobLog");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'jobLog',
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      jobNameList: [],
      listQuery: {
        page: 1,
        limit: 10,
        jobName: undefined,
        dataId: undefined,
        logStatus: undefined
      }
    };
  },
  created: function created() {
    // 检查路由参数
    var dataId = this.$route.query.dataId;
    if (dataId) {
      this.listQuery.dataId = dataId;
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          dataId: undefined
        })
      });
    }
    this.getList();
    this.getJobNameList();
  },
  methods: {
    getList: function getList(data) {
      var _this = this;
      this.listLoading = true;
      if (data) {
        this.listQuery.page = data.page;
        this.listQuery.limit = data.limit;
      }
      (0, _jobLog.queryJobLogPage)(this.listQuery).then(function (response) {
        if (response.code === 200) {
          _this.list = response.records;
          _this.total = response.total;
        } else {
          _this.handleWarning(response.data.message);
        }
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.listQuery.jobName = undefined;
      this.listQuery.dataId = undefined;
      this.listQuery.logStatus = undefined;
      this.handleFilter();
    },
    // 格式化日期时间
    formatDateTime: function formatDateTime(dateTime) {
      if (!dateTime) return '';
      var date = new Date(dateTime);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    // 获取任务名称列表
    getJobNameList: function getJobNameList() {
      var _this2 = this;
      (0, _jobLog.getJobName)().then(function (response) {
        if (response && response.code === 200) {
          _this2.jobNameList = response.data || [];
        }
      }).catch(function () {
        _this2.jobNameList = [];
      });
    }
  }
};